import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/quiz/leaderboard?limit=10');
      if (response.data.success) {
        setLeaderboard(response.data.data);
      } else {
        setError('Failed to load leaderboard');
      }
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      setError('Failed to load leaderboard');
    } finally {
      setLoading(false);
    }
  };

  const getRankIcon = index => {
    switch (index) {
      case 0:
        return '🥇';
      case 1:
        return '🥈';
      case 2:
        return '🥉';
      default:
        return `#${index + 1}`;
    }
  };

  if (loading) {
    return (
      <div className='card' style={{ marginBottom: '2rem' }}>
        <div className='card-header'>
          <h3 style={{ margin: 0, color: 'white' }}>🏆 Leaderboard</h3>
        </div>
        <div className='card-body' style={{ textAlign: 'center', padding: '2rem' }}>
          <div className='loading-spinner'></div>
          <p style={{ color: 'rgba(255,255,255,0.7)', marginTop: '1rem' }}>
            Loading leaderboard...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='card' style={{ marginBottom: '2rem' }}>
        <div className='card-header'>
          <h3 style={{ margin: 0, color: 'white' }}>🏆 Leaderboard</h3>
        </div>
        <div className='card-body' style={{ textAlign: 'center', padding: '2rem' }}>
          <p style={{ color: '#ff6b6b' }}>{error}</p>
          <button onClick={fetchLeaderboard} className='btn btn-secondary'>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (leaderboard.length === 0) {
    return (
      <div className='card' style={{ marginBottom: '2rem' }}>
        <div className='card-header'>
          <h3 style={{ margin: 0, color: 'white' }}>🏆 Leaderboard</h3>
        </div>
        <div className='card-body' style={{ textAlign: 'center', padding: '2rem' }}>
          <p style={{ color: 'rgba(255,255,255,0.7)' }}>
            No scores yet! Be the first to complete a quiz.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='card' style={{ marginBottom: '2rem' }}>
      <div className='card-header'>
        <h3 style={{ margin: 0, color: 'white' }}>🏆 Leaderboard</h3>
        <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>
          Top players by lifetime score
        </p>
      </div>
      <div className='card-body' style={{ padding: 0 }}>
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {leaderboard.map((player, index) => (
            <div
              key={player.userId}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '1rem',
                borderBottom:
                  index < leaderboard.length - 1 ? '1px solid rgba(255,255,255,0.1)' : 'none',
                backgroundColor: index < 3 ? 'rgba(255, 165, 0, 0.1)' : 'transparent',
              }}
            >
              {/* Rank */}
              <div
                style={{
                  minWidth: '60px',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  color: index < 3 ? '#FFA500' : 'white',
                }}
              >
                {getRankIcon(index)}
              </div>

              {/* User Info */}
              <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                {player.picture && (
                  <img
                    src={player.picture}
                    alt={player.name}
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      marginRight: '1rem',
                      border: '2px solid rgba(255,255,255,0.2)',
                    }}
                  />
                )}
                <div>
                  <div
                    style={{
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '1rem',
                    }}
                  >
                    {player.name}
                  </div>
                  <div
                    style={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '0.8rem',
                    }}
                  >
                    {player.totalQuizzes} quiz{player.totalQuizzes !== 1 ? 'es' : ''} •{' '}
                    {player.accuracyRate}% accuracy
                  </div>
                </div>
              </div>

              {/* Stats */}
              <div style={{ textAlign: 'right', minWidth: '120px' }}>
                <div
                  style={{
                    color: '#FFA500',
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                  }}
                >
                  {player.lifetimeScore.toLocaleString()}
                </div>
                <div
                  style={{
                    color: 'rgba(255,255,255,0.7)',
                    fontSize: '0.8rem',
                  }}
                >
                  Avg: {player.averageScore}% • Best: {player.bestScore}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
